// extracted by mini-css-extract-plugin
export var banner = "hotel-card-module--banner--0W8Fd";
export var bannerContainer = "hotel-card-module--bannerContainer--g79JO";
export var bannerPrice = "hotel-card-module--bannerPrice--k1SOd";
export var bannerPriceText = "hotel-card-module--bannerPriceText--oGzXP";
export var card = "hotel-card-module--card--UavYp";
export var catchcopy = "hotel-card-module--catchcopy--jcFX4";
export var comment = "hotel-card-module--comment--nwXxq";
export var copyBlock = "hotel-card-module--copyBlock--QoDbv";
export var couponLink = "hotel-card-module--couponLink--Y3wEM";
export var ctaText = "hotel-card-module--ctaText--zkrTL";
export var hotelLink = "hotel-card-module--hotelLink--1dQmf";
export var ikyuLink = "hotel-card-module--ikyuLink--S2rKJ";
export var infoBody = "hotel-card-module--infoBody--uZNaA";
export var infoBox = "hotel-card-module--infoBox--j2wYW";
export var infoTable = "hotel-card-module--infoTable--7R6G2";
export var infoTableWrap = "hotel-card-module--infoTableWrap--NoX5P";
export var infoTitle = "hotel-card-module--infoTitle--5NC24";
export var jalanLink = "hotel-card-module--jalanLink--m+khj";
export var linkGrid = "hotel-card-module--linkGrid--YtsQQ";
export var linkGroup = "hotel-card-module--linkGroup--pZDQq";
export var mainImage = "hotel-card-module--mainImage--bmZ9t";
export var mainImageWrap = "hotel-card-module--mainImageWrap--Ic9F4";
export var rakutenLink = "hotel-card-module--rakutenLink--h8T5H";
export var roomImage = "hotel-card-module--roomImage--ucZNC";
export var roomImageWrap = "hotel-card-module--roomImageWrap--i5pB9";
export var serviceBadge = "hotel-card-module--serviceBadge--pQ66M";
export var summary = "hotel-card-module--summary--qCrbf";
export var title = "hotel-card-module--title--A2rQ5";
export var viewText = "hotel-card-module--viewText--tzAWN";
export var yahooLink = "hotel-card-module--yahooLink--QSYZG";